module.exports = __webpack_public_path__ + "img/Z82_08.788cd6eb.jpg";